export type FeatureName = 'cogfy-assistant'

const HOSTS_WITH_COGFY_ASSISTANT = [
  'app.cogfy.com',
  'staging.app.cogfy.com',
  'localhost:5173'
]

export function isFeatureAvailable (feature: FeatureName): boolean {
  const host = window?.location?.host ?? ''

  switch (feature) {
    case 'cogfy-assistant':
      return HOSTS_WITH_COGFY_ASSISTANT.includes(host)
    default:
      return false
  }
}
